export function getAuthSuccessRedirect(routeQuery) {

    return routeQuery?.redirect || null;

}
